import { FontEntry } from '../../types/font'

export const tomorrow: FontEntry = {
  displayName: 'Tomorrow',
  weights: {
    300: {
      normal: { file: 'Tomorrow-Light', extension: 'ttf', format: 'truetype' },
      italic: null
    },
    400: {
      normal: { file: 'Tomorrow-Regular', extension: 'ttf', format: 'truetype' },
      italic: null
    }
  }
}
